module.exports = __webpack_public_path__ + "img/Chamada-formulario.89c30856.png";